module.exports = __webpack_public_path__ + "static/assets/1800cd6f0140fb892bc55c36244b9176.png";